var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.modal_id,
            title: "入金",
            "header-bg-variant": "dark",
            "header-text-variant": "light",
            "body-bg-variant": "light",
            "hide-footer": "",
            centered: "",
            scrollable: "",
          },
          on: { hide: _vm.closeModal },
        },
        [
          _c("div", [
            _c(
              "div",
              { staticClass: "form-inline" },
              [
                _c("label", { staticClass: "block_label2" }, [_vm._v("顧客")]),
                _vm._v(" "),
                _c("b-input", {
                  staticStyle: { width: "300px" },
                  attrs: { type: "text", disabled: "" },
                  model: {
                    value: _vm.client_company,
                    callback: function ($$v) {
                      _vm.client_company = $$v
                    },
                    expression: "client_company",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-inline" },
              [
                _c("label", { staticClass: "block_label2" }, [_vm._v("品題")]),
                _vm._v(" "),
                _c("b-input", {
                  staticStyle: { width: "200px" },
                  attrs: { type: "text", disabled: "" },
                  model: {
                    value: _vm.mitumori.title,
                    callback: function ($$v) {
                      _vm.$set(_vm.mitumori, "title", $$v)
                    },
                    expression: "mitumori.title",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-inline" },
              [
                _c("label", { staticClass: "block_label2" }, [
                  _vm._v("請求日"),
                ]),
                _vm._v(" "),
                _c("b-input", {
                  staticStyle: { width: "150px" },
                  attrs: { type: "text", disabled: "" },
                  model: {
                    value: _vm.nyukin.seikyu_on_fmt,
                    callback: function ($$v) {
                      _vm.$set(_vm.nyukin, "seikyu_on_fmt", $$v)
                    },
                    expression: "nyukin.seikyu_on_fmt",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-inline" },
              [
                _c("label", { staticClass: "block_label2" }, [
                  _vm._v("請求額"),
                ]),
                _vm._v(" "),
                _c("b-input", {
                  staticStyle: { width: "100px", "text-align": "right" },
                  attrs: { type: "text", disabled: "" },
                  model: {
                    value: _vm.nyukin.price_fmt,
                    callback: function ($$v) {
                      _vm.$set(_vm.nyukin, "price_fmt", $$v)
                    },
                    expression: "nyukin.price_fmt",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-inline" },
              [
                _c("label", { staticClass: "block_label2" }, [
                  _vm._v("入金日"),
                ]),
                _vm._v(" "),
                _c("b-input", {
                  staticStyle: { width: "150px" },
                  attrs: { type: "text", disabled: "" },
                  model: {
                    value: _vm.nyukin.nyukin_on_fmt,
                    callback: function ($$v) {
                      _vm.$set(_vm.nyukin, "nyukin_on_fmt", $$v)
                    },
                    expression: "nyukin.nyukin_on_fmt",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-inline" },
              [
                _c("label", { staticClass: "block_label2" }, [_vm._v("入金")]),
                _vm._v(" "),
                _c("b-input", {
                  staticStyle: { width: "100px", "text-align": "right" },
                  attrs: { type: "text", disabled: "" },
                  model: {
                    value: _vm.nyukin.nyukin_price_fmt,
                    callback: function ($$v) {
                      _vm.$set(_vm.nyukin, "nyukin_price_fmt", $$v)
                    },
                    expression: "nyukin.nyukin_price_fmt",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-inline" },
              [
                _c("label", { staticClass: "block_label2" }, [_vm._v("返品")]),
                _vm._v(" "),
                _vm.henpin
                  ? _c("b-input", {
                      staticStyle: { width: "100px", "text-align": "left" },
                      attrs: {
                        value: _vm.henpin_status ? "未完" : "完",
                        type: "text",
                        disabled: "",
                      },
                    })
                  : _c("b-input", {
                      staticStyle: { width: "100px", "text-align": "left" },
                      attrs: { value: "-", type: "text", disabled: "" },
                    }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }